export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const MARK_NOTIFICATIONS_AS_READ = "MARK_NOTIFICATIONS_AS_READ";

export const NOTIFICATIONS = "NOTIFICATIONS";
export const NOTIFICATIONS_LOADING = "NOTIFICATIONS_LOADING";
export const RESET_NOTIFICATION_STATE = "RESET_NOTIFICATION_STATE";
